<template>
  <v-card max-width="800" class="mb-14">
    <div
      class="d-flex justify-end"
      style="position: absolute; top: 0; width: 100%"
    >
      <v-btn
        icon
        @click="open = false"
        variant="outlined"
        color="error"
        size="small"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <iframe
      style="max-width: 77vw"
      v-if="isYoutube"
      :width="isMobileMode ? '300' : '560'"
      :height="isMobileMode ? '160' : '315'"
      :src="youtubeUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
    <video
      v-else
      style="width: 100%"
      controls
      ref="videoPlayer"
      :src="media.url"
    />
    <div class="text-primary px-5 py-4">
      <v-range-slider
        v-model="selectedRange"
        :min="0"
        :max="videoDuration"
        strict
        thumb-label="always"
        color="#2196F3"
        track-color="#2196F3"
      >
        <template v-slot:thumb-label="{ modelValue }">
          {{ formatTime(modelValue) }}
          <!-- <v-icon :icon="season(modelValue)" theme="dark"></v-icon> -->
        </template>
      </v-range-slider>
      <!-- <v-range-slider
        v-if="!loading"
        label-always
        v-model="selectedRange"
        :min="0"
        :max="100"
        label
        drag-range
        color="#2196F3"
        :left-label-value="formattedStartTime"
        :right-label-value="formattedEndTime"
      /> -->

      <div v-if="!validLength" class="d-flex justify-center">
        <span class="text-error">{{ $t('video.tooLong') }}</span>
      </div>
      <!-- sum time chosen  -->
      <div class="d-flex justify-center">
        <span class="text-primary" v-if="!loading">{{
          `${$t('video.chosenLength')}: ${length.toFixed(0)} ${$t(
            'generics.seconds'
          )}`
        }}</span>
      </div>
      <div class="d-flex justify-center" style="gap: 16px">
        <v-btn
          v-if="!loading"
          color="primary"
          @click="trim"
          :disabled="!validLength"
        >
          {{ $t('video.save') }}
        </v-btn>
        <v-btn @click="continueHandler" v-if="allowSkip" color="primary">
          {{ $t('generics.continue') }}
        </v-btn>
      </div>
    </div>
    <v-overlay :model-value="loading" scrim="transparent">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import localforage from 'localforage'

import { youTubeLength } from '@/api/mediaApi'
import { useSwal } from '@/composables/useSwal'
import { useAuthStore } from '@/store/auth'
export default {
  name: 'VideoCropper',
  setup() {
    const { createSwal } = useSwal()
    const { isAdmin } = storeToRefs(useAuthStore())
    return { createSwal, isAdmin }
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Object,
      default: null,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    redirect: {
      type: String,
      default: '',
    },
    youtubeUrl: {
      type: String,
      default: '',
    },
    isYoutube: {
      type: Boolean,
      default: false,
    },
    allowSkip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sliderTime: 0,
      currentTime: 0,
      selectedRange: [0, 100],
      videoDuration: 0,
      playing: false,
      stopTimeout: null,
      loading: false,
    }
  },
  async mounted() {
    if (!this.isNew && this.isYoutube) {
      this.videoDuration = await youTubeLength(
        this.youtubeUrl.split('embed/')[1]
      )
      // parse the URL
      const parsedUrl = new URL(this.youtubeUrl)
      // get query params
      const start = parsedUrl.searchParams.get('start') || 0
      const end = parsedUrl.searchParams.get('end') || this.videoDuration
      this.selectedRange = [start, end]
    } else if (this.isYoutube) {
      this.loading = true
      try {
        this.videoDuration = await youTubeLength(
          this.youtubeUrl.split('embed/')[1]
        )
        this.selectedRange = [0, +this.videoDuration]
        this.loading = false
      } catch (e) {
        if (e.response.data.error === 'Private video') {
          setTimeout(() => {
            this.open = false
          }, 1000)
          return this.timeoutSwal({
            title: this.$t('images.privateVideoError'),
            icon: 'error',
            timer: 1000,
          })
        }
        this.loading = false
        return this.$emit('saveUrl', this.youtubeUrl)
      } finally {
        this.loading = false
      }
    }
    this.$refs.videoPlayer?.addEventListener?.('loadedmetadata', () => {
      this.videoDuration = this.$refs.videoPlayer.duration
    })
  },
  computed: {
    open: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
    isMobileMode() {
      return this.$vuetify.display.mobile
    },
    // formattedStartTime() {
    //   return this.formatTime(this.range.start)
    // },
    // formattedEndTime() {
    //   return this.formatTime(this.range.end)
    // },
    range() {
      return {
        start: Math.round(this.selectedRange[0]),
        end: Math.round(this.selectedRange[1]),
      }
    },
    length() {
      return this.range.end - this.range.start
    },
    validLength() {
      if (this.isYoutube) return true
      const maxDuration = this.isAdmin ? 120 : 30
      return this.length <= maxDuration
    },
  },

  methods: {
    // formatLabel(value) {
    //   return this.formatTime(value)
    // },
    continueHandler() {
      this.open = false
      this.$emit('continue')
    },
    saveYoutube() {
      const url = new URL(this.youtubeUrl)
      url.searchParams.set('start', Math.floor(this.range.start))
      url.searchParams.set('end', Math.floor(this.range.end))
      this.$emit('saveUrl', url.toString())
      this.open = false
    },
    trim() {
      if (this.isYoutube) {
        this.saveYoutube()
        return
      }
      this.saveFile(this.media)
    },
    async saveFile(file) {
      try {
        await localforage.setItem('fileKey', file)
        console.log('File saved to IndexedDB')
        //query url builder
        const query = new URLSearchParams({
          file_key: 'fileKey',
          start_time: this.range.start,
          length_time: this.length,
          redirect: this.redirect || window.location.href,
          lang: this.$i18n.locale,
        }).toString()
        window.location.href = `${process.env.VITE_BASE_URL}/video-trimmer?${query}`
      } catch (error) {
        console.error('Error saving file to IndexedDB', error)
      }
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = Math.floor(seconds % 60)
      return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
/* Add your custom styles here */
.thumb-label {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
